const benefits = [
  {
    icon: 'ri-search-eye-line',
    title: 'Szybsze wyszukiwanie',
    desc: 'Nie trać godzin na ręczne szukanie produktów. Wszystko, czego potrzebujesz, masz w jednym miejscu – uporządkowane i gotowe do przeglądania.',
  },
  {
    icon: 'ri-apps-2-line',
    title: 'Kategorie produktów',
    desc: 'Sneakersy, ubrania, akcesoria i wiele więcej – wszystkie kategorie są starannie posegregowane dla Twojej wygody.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Porównania',
    desc: 'Przejrzysta tabela pomaga szybko porównać produkty i wybrać najlepszą opcję spośród dostępnych propozycji.',
  },
  {
    icon: 'ri-shield-flash-line',
    title: 'Bezpieczeństwo',
    desc: 'Dowiedz się, jak ograniczyć ryzyko podczas zakupów online i uniknąć potencjalnych problemów.',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
            Dlaczego użytkownicy wybierają Kakobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Odkryj, co sprawia, że tysiące użytkowników codziennie korzysta z naszej bazy produktów
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {benefits.map((benefit, i) => (
            <div
              key={i}
              className="group p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-4 group-hover:bg-accent-200/70 transition-colors">
                <i className={`${benefit.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2">
                {benefit.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {benefit.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}